
const SelectMentalhealthProvider = () => {
  return (
    <div className="flex flex-col w-[calc(100%-47%)] m-auto mt-0 pt-0"></div>
  );
};

export default SelectMentalhealthProvider;
